import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { RegisteredCompanyModel } from '../../admin/models/CompanyModels';
import { localizations } from '../../localization/localization';

type SubmitType = () => void;
type CancelType = () => void;

interface DeleteUserConfirmProps {
    companyId: string
}

type Props = DialogPropsBase<SubmitType, CancelType> & DeleteUserConfirmProps;

const DeleteCompanyForm: React.SFC<Props> = (props) => {
    return <Dialog open={true}>
        <DialogTitle>{localizations.settings.deleteCompanyConfirmationTitle}</DialogTitle>
        <DialogContent>
            <Typography paragraph variant="body2">{localizations.settings.deleteCompanyQuestion}</Typography>
            <Typography paragraph variant="body2">{localizations.settings.deleteCompanyDescription}</Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onCancel()}>{localizations.actions.cancel}</Button>
            <Button onClick={() => props.onSubmit()}>{localizations.actions.accept}</Button>
        </DialogActions>
    </Dialog>
}

export default DeleteCompanyForm;


// WEBPACK FOOTER //
// ./src/account/forms/DeleteCompanyForm.tsx